// @ts-nocheck
/* eslint-disable */

import { useState, ReactNode } from "react";

//scss
import "global/style.scss";

//components
import RenderHTML from "components/RenderHTML";

interface DataType {
	children: ReactNode;
	numWords?: number;
	btnText?: string;
	marginTop?: any;
	onReadMoreClick?: any;
	type?: string;
	textColor?: string;
}

const ReadMoreWrapper = ({
	children,
	numWords = 40,
	btnText = "",
	marginTop,
	onReadMoreClick,
	type,
	textColor,
}: DataType) => {
	const [isOpen, setIsOpen] = useState(!(getnumWords(children) > numWords));
	const [isHovering, setIsHovering] = useState(false);

	const handleMouseEnter = () => {
		setIsHovering(true);
	};

	const handleMouseLeave = () => {
		setIsHovering(false);
	};

	return (
		<>
			<div className="s" style={{ marginTop: marginTop }}>
				<RenderHTML>
					{getnumWords(children) > numWords && !isOpen
						? returnNWords(children, numWords) + "..."
						: children}
				</RenderHTML>
				{getnumWords(children) > numWords && (
					<span
						onClick={() => {
							if (type === "header") {
								onReadMoreClick();
							} else {
								setIsOpen(!isOpen);
							}
						}}
						style={{
							cursor: "pointer",
							textDecoration:
								isHovering || type === "header" ? "underline" : " ",
							fontSize: textColor === "#333333" ? "12px" : "14px",
							fontWeight: "500",
							color: type === "header" ? "textColor !important" : "#2368a2",
						}}
						onMouseEnter={handleMouseEnter}
						onMouseLeave={handleMouseLeave}
					>
						Read {isOpen ? "less" : "more"}
					</span>
				)}
			</div>
		</>
	);
};

export default ReadMoreWrapper;

const getnumWords = (string: any) => {
	if (!string) return;
	return string?.length > 0 && string?.split(" ").length;
};
const returnNWords = (string: any, n = 50) => {
	if (!string) return;
	return string?.length > 0 && string?.split(" ").slice(0, n).join(" ");
};
